import { BrowserRouter, Route, Routes } from "react-router-dom";

import AlertProvider from "./components/alert/AlertProvider";
import AuthProvider from "./components/auth/AuthProvider";
import FillView from "./components/fillView/FillView";

import AdminLayout from "./layouts/AdminLayout";

import { ExportReports } from "./components/exportReports/ExportReports";
import { ForgottenPassword } from "./components/forgottenPassword/ForgottenPassword";
import { Login } from "./components/login/Login";
import Admin from "./pages/admin/Admin";
import NoPage from "./pages/noPage/NoPage";
import Public from "./pages/public/Public";

const App = () => {
  return (
    <FillView>
      <AlertProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Admin />} />
                <Route path=":fareZoneId" element={<Admin />} />
                <Route path="login" element={<Login />} />
                <Route path="exports" element={<ExportReports />} />
                <Route
                  path="forgottenPassword"
                  element={<ForgottenPassword />}
                />
              </Route>
              <Route path="/:fareZoneId/:psCode?" element={<Public />} />
              <Route path="*" element={<NoPage />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AlertProvider>
    </FillView>
  );
};

export default App;
